// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoDialog_wrapper__g9cPu","image":"InfoDialog_image__RH0uK","footer":"InfoDialog_footer__DGiav"};